<div class="onboarding">
    <div class="semi-background">
        <div class="col-md-10 mx-auto">
            <token-header></token-header>

            <div class="content mt-0 mt-md-3">
                <div class="token-content py-5">
                    <div class="pt-3">
                        <h4 class="text-center message-icon"><i class="fa-solid fa-users fa-2x"></i></h4>
                        <h4 class="text-center">{{ 'onboarding.token.already_in_team.title' | translate}}</h4>
                        <p class="text-center">{{ 'onboarding.token.already_in_team.description' | translate}}</p>
                        <div class="text-center mt-3">
                            <a class="btn btn-primary btn-lg" href="https://app.teammood.com/app#/login">{{ 'onboarding.token.already_in_team.action' | translate}}</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>